export const DATADOG_ENABLED =
  process.env.NEXT_PUBLIC_DATADOG_ENABLED === "true";
